import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const DEFAULT_FIRST_DAY_OF_WEEK = 0;
const FirstDayOfWeekContext = createContext(DEFAULT_FIRST_DAY_OF_WEEK);
const FirstDayOfWeekProvider = (props) => {
    var _a;
    const firstDayOfWeek = (_a = props.firstDayOfWeek) !== null && _a !== void 0 ? _a : DEFAULT_FIRST_DAY_OF_WEEK;
    return jsx(FirstDayOfWeekContext.Provider, Object.assign({ value: firstDayOfWeek }, { children: props.children }));
};
const useFirstDayOfWeek = () => useContext(FirstDayOfWeekContext);

export { FirstDayOfWeekProvider, useFirstDayOfWeek };
//# sourceMappingURL=firstDayOfWeek.js.map
